import type { BaseFieldStore } from '../Stores/BaseFieldStore'
import { FieldType } from '../Stores/Types/FieldTypeEnum'
import { BaseFieldInputStrategy } from './BaseFieldInputStrategy'

/**
 * Стратегія для file полів
 * File input підтримує власну множинність через mode="multiple"
 */
export class FileFieldStrategy extends BaseFieldInputStrategy {
    fieldType: FieldType = FieldType.FILE
    
    /**
     * File підтримує власну множинність через mode="multiple"
     */
    supportsNativeMultiple = true

    /**
     * Модифікує props для File компонента
     * Автоматично додає mode="multiple" для множинних полів
     */
    modifyInputProps(props: Record<string, any>, field: BaseFieldStore): Record<string, any> {
        // Якщо поле множинне, додаємо mode="multiple"
        if (field.definition.isMultiple === true && !props.mode) {
            props.mode = 'multiple'
        }
        
        return props
    }
}
